import { render, staticRenderFns } from "./details.vue?vue&type=template&id=3a4edc8c&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=3a4edc8c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4edc8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a4edc8c')) {
      api.createRecord('3a4edc8c', component.options)
    } else {
      api.reload('3a4edc8c', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=3a4edc8c&scoped=true", function () {
      api.rerender('3a4edc8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/sharing_agreement/configuration_list/form/details/details.vue"
export default component.exports